import { putResolve, select, takeEvery } from 'redux-saga/effects';
import {
    NURSE_DEPLOYMENT_RESOURCE,
    NURSE_REQUEST_RESOURCE,
    NURSE_SUGGESTION_RESOURCE,
} from '../api/resources';
import { showCareNeed } from './careNeedsSlice';

/*
 * careNeed.agencyId is set and released by the backend (CareNeed::syncAgency()) when a
 * BK-Vorschlag is confirmed, rejected or deleted, or a BK-Einsatz is created or deleted
 * (docs/plans/care-need-single-agency.md). The socket event for that CareNeed comes
 * delayed and may be switched off, so the BK-Bedarf is reloaded right away - otherwise
 * "+ Einsatz" would still say "noch keine Agentur" right after confirming.
 */

const RESOURCES = [NURSE_DEPLOYMENT_RESOURCE, NURSE_SUGGESTION_RESOURCE];
const typePattern = new RegExp(
    `^(${RESOURCES.join('|')})/(store|update|destroy)(Pending|Fulfilled)$`
);

// care needs of entities being deleted - captured while they're still in the store
const pendingDestroys = {};

const careNeedIdsOf = (state, resource, item) => {
    if (!item) return [];
    if (resource === NURSE_DEPLOYMENT_RESOURCE) {
        return item.careNeedId ? [item.careNeedId] : [];
    }
    const request = state[NURSE_REQUEST_RESOURCE]?.byId?.[item.nurseRequestId];
    return (request && request.careNeedIds) || [];
};

function* handleChange({ type, payload, meta }) {
    const [, resource, action, phase] = typePattern.exec(type);

    if (action === 'destroy') {
        const id = meta?.params?.id;
        if (phase === 'Pending') {
            const item = yield select((state) => state[resource]?.byId?.[id]);
            pendingDestroys[`${resource}.${id}`] = yield select((state) =>
                careNeedIdsOf(state, resource, item)
            );
            return;
        }
        const careNeedIds = pendingDestroys[`${resource}.${id}`] || [];
        delete pendingDestroys[`${resource}.${id}`];
        yield* reload(careNeedIds);
        return;
    }

    // other users' changes arrive as socket events, the CareNeed's own included
    if (phase !== 'Fulfilled' || meta?.socketReaction) return;
    const careNeedIds = yield select((state) => careNeedIdsOf(state, resource, payload));
    yield* reload(careNeedIds);
}

function* reload(careNeedIds) {
    for (const id of careNeedIds) {
        try {
            yield putResolve(showCareNeed({ id }));
        } catch (error) {
            // best effort - the socket event or the next load catches up
        }
    }
}

export default [takeEvery((action) => typePattern.test(action.type), handleChange)];
